import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { ComponentsModule } from './shared/components/components.module';
import { HttpClientModule } from '@angular/common/http';

const config = {
  apiKey: 'AIzaSyCG5nXc-mJ5dgFtqNuofze_uPfGTw5XdjI',
  authDomain: 'haciendamarillo.firebaseapp.com',
  projectId: 'haciendamarillo',
  storageBucket: 'haciendamarillo.appspot.com',
  messagingSenderId: '869416639040',
  appId: '1:869416639040:web:270e92d7303259e70cdda5',
  measurementId: 'G-B02F5QFKWF',
};

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    ComponentsModule,
    AngularFirestoreModule, // firestore
    AngularFireAuthModule, // auth
    AngularFireStorageModule, // storage
    AngularFireModule.initializeApp(config),
    HttpClientModule,
  ],
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }],
  bootstrap: [AppComponent],
})
export class AppModule {}
